import { render } from "./DanhSachToaXe.vue?vue&type=template&id=e1bbb562&ts=true"
import script from "./DanhSachToaXe.vue?vue&type=script&lang=ts"
export * from "./DanhSachToaXe.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__